import './scripts/common';
import {onFind} from "@elements/init-modules-in-scope";
import {find, addClass, findAll, on, findAllIn, setAttribute} from "@elements/dom-utils";

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

import Modal from 'bootstrap/js/dist/modal';
onFind('[data-bs-toggle="modal"]',function (element) {
    new Modal(element);
});

// import * as ajaxForm from '@elements/ajax-form';
// ajaxForm.init();

import * as projectTeaser from './scripts/project-teaser'
projectTeaser.init();

import * as infiniteGrid from './scripts/infinite-grid'
infiniteGrid.init();